import { zodUnionWithTelemetry } from "@/telemetry/helpers/zod";
import { CartesiaTTS, cartesiaTTSConfig } from "./providers/cartesia";

// Providers
export const ttsProviders = {
  cartesia: { class: CartesiaTTS, configSchema: cartesiaTTSConfig },
} as const;

export type TTSProvider = (typeof ttsProviders)[keyof typeof ttsProviders]["class"];

// Config
export const ttsProviderConfig = zodUnionWithTelemetry("provider", [cartesiaTTSConfig]);
